import { useEffect, useState } from 'react';
import axios from 'axios';
import { Spin } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';

const AuthWrapper = ({ children }) => {
  const [authChecked, setAuthChecked] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const response = await axios.get(
          'https://whatsappproapi.defconinnovations.com/api/check-auth/',
          {
            withCredentials: true,
          }
        );

        const data = response.data;

        if (response.status === 200 && data.is_authenticated) {
          localStorage.setItem('auth', JSON.stringify(data));
          setIsAuthenticated(true);
        } else {
          // Not authenticated
          window.location.href =
            'https://whatsappproapi.defconinnovations.com?next=https://whatsapppro.defconinnovations.com/';
        }
      } catch (error) {
        setAuthChecked(true);
        console.log('Auth check failed:', error);
        if (process.env.REACT_APP_SANDBOX === 'true') {
          localStorage.setItem(
            'auth',
            JSON.stringify({
              is_authenticated: true,
              username: 'ubaidjogi',
              full_name: 'Ubaid Jogi',
              access_token: process.env.REACT_APP_access_token,
              /* refresh_token: import.meta.env.VITE_REACT_APP_refresh_token, */
              org: 1,
              userid: 17,
            })
          );
          setIsAuthenticated(true);
        } else {
          window.location.href = window.location.href =
            'https://whatsappproapi.defconinnovations.com?next=https://whatsapppro.defconinnovations.com/';
        }
      } finally {
        setAuthChecked(true);
      }
    };

    checkAuth();
  }, [navigate, location.pathname]);

  if (!authChecked) {
    return (
      <div className="flex items-center justify-center h-screen bg-white">
        <Spin size="large" />
      </div>
    );
  }

  return isAuthenticated ? children : null;
};

export default AuthWrapper;
